export const getSx = () => {
  return {
    muiButton: {
      height: '50px',
      maxWidth: "280px",
      borderRadius: '12px',
      padding: '20px 30px',
      fontSize: '16px',
      color: '#FFFFFF',
      background: "#0832DE",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      fontWeight: 500,
      '&.Mui-disabled': {
        background: "#0832DE",
        opacity: '0.3',
        color: '#FFFFFF',
      },

      '&:hover': {
        color: '#FFFFFF',
        background: "#0832DE",
      },
    },
    successButton: {
      color: '#FFFFFF',
      background: "#0832DE",

      fontWeight: 500,
      '&.Mui-disabled': {
        backgroundColor: '#0832DE',
      },

      '&:hover': {
        background: '#0832DE',
      },
    },
    errorButton: {
      background: 'transparent',
      color: "#F71111",
      border: "1px solid rgba(247, 17, 17, 0.40)",

      '&.Mui-disabled': {
        opacity: '0.3',
        color: "#F71111",
        background: 'transparent',
        border: "1px solid rgba(247, 17, 17, 0.40)",
      },

      '&:hover': {
        color: "#F71111",
        background: 'transparent',
        border: "1px solid rgba(247, 17, 17, 0.40)",
      },
    },
    disabled: {
      background: '#8699A1',

      '&.Mui-disabled': {
        background: '#8699A1',
      },

      '&:hover': {
        background: '#8699A1',
      },
    },
    inactive: {
      opacity: '0.4',
      color: '#383838',
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 148, 217, 0.40)',
      "&:hover": { opacity: '0.4', color: '#383838', backgroundColor: 'rgba(0, 148, 217, 0.40)', boxShadow: 'none' }
    }
  };
};
